<template>
  <div class="portlet-body form">
    <div v-show="loading !== 0" class="row">
      <div class="col-sm-12">
        <span>
            <div class="progress" style="margin: 20px 0;">
                <div
                  :aria-valuemax="progress"
                  :aria-valuenow="loading"
                  :style="{ width: currentProgress + '%' }"
                  aria-valuemin="0"
                  class="progress-bar"
                  role="progressbar"
                >
                  <span class="sr-only">{{ currentProgress }}% Complete</span>
                </div>
            </div>
            <h2>{{ trans('form.please_wait') }}...</h2>
            <ring-loader/>
        </span>
      </div>
    </div>
    <template v-for="(meal, mealDate, index) in meals">
      <div v-show="loading === 0" :key="index">
        <div class="row show-block-button">
          <div class="col-md-6" style="padding-left: 0">
            <h3>
              {{ mealDate }}
              {{ getDayNameFromDate(mealDate) }}
              (<span v-tooltip.top="trans('menu_planner.uniq_meal_count')">{{ countUniqMeals(mealDate) }}</span>)
            </h3>
          </div>
          <div class="col-md-6" style="padding-right: 0">
            <div v-if="isGranted()" class="btn-set pull-right">
              <button class="btn green" @click="editMenu(mealDate)">{{ trans('menu_planner.edit') }}</button>
            </div>
            <div v-if="isGranted()" class="btn-set pull-right" style="margin-right:8px;">
              <button class="btn btn-default" @click="showControlReport(mealDate)">
                {{ trans('menu_planner.control_report') }}
              </button>
            </div>
            <div class="btn-set pull-right" style="margin-right:8px;">
              <menu-planner-history
                :brand="brand"
                :date="mealDate"
                route-name="api_get_entity_logger_show_menu_planner_serving"
              />
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 20px;">
          <div class="col-sm-12">
            <table id="menu-planner-table-show" class="table table-bordered" style="margin-bottom: 0;">
              <tbody>
              <tr>
                <td class="menu-header" style="width: 75px; min-width: 75px;">&nbsp;</td>
                <td
                  v-for="(mealType, typeIndex) in mealTypes"
                  :key="typeIndex"
                  class="menu-header"
                  style="width: 150px; min-width: 150px;"
                >
                  <b>{{ mealType.name }}</b>
                </td>
              </tr>
              <tr v-for="(variant, variantIndex) in variants" :key="variantIndex">
                <td class="menu-header"><b>{{ variant.name }}</b></td>
                <td v-for="(mealType, typeIndex) in mealTypes" :key="typeIndex">
                  {{ getMealName(variant.id, mealType.id, mealDate) }}
                  <div style="text-align: right; font-size: 0.8em">
                    <span class="glyphicon glyphicon-play">
                      {{ getProductionCost(variant.id, mealType.id, mealDate) }}
                    </span>
                  </div>
                  <div style="text-align: right; font-size: 0.8em">
                    <span class="glyphicon glyphicon-star">
                      {{ getMealAvgRate(variant.id, mealType.id, mealDate) }}
                    </span>
                  </div>
                  <div
                      v-for="badge in getMealBadges(variant.id, mealType.id, mealDate)"
                      :key="badge.id"
                      style="text-align: right; font-size: 0.8em; font-weight: bold;"
                  >
                    <a @click.prevent="showMealBadge(badge.id)">
                      <i class="fa fa-link"></i>&nbsp;{{ badge.name }}
                    </a>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import bootbox from 'bootbox'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import MenuPlannerHistory from '@component/view/MenuPlannerHistory.vue'

export default {
  components: {
    MenuPlannerHistory,
    RingLoader
  },
  props: {
    date: {
      type: [String, Date],
      default: ''
    },
    brand: {
      type: [String, Number],
      default: ''
    },
    package: {
      type: [String, Number],
      default: ''
    },
  },
  data() {
    return {
      loading: 0,
      hasExpress: false,
      progress: 0,
      meals: [],
      variants: [],
      mealTypes: [],
    }
  },
  computed: {
    currentProgress() {
      if (this.progress === 0) {
        return 0
      }

      return (1 - this.loading / this.progress) * 100
    },
    requestParams() {
      return `${this.date}${this.brand}${this.package}`
    }
  },
  watch: {
    'requestParams'() {
      this.load()
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.meals = []
      this.variants = []
      this.mealTypes = []

      this.getVariants()
      this.getMealTypes()
      this.getMeals()
    },
    editMenu(date) {
      const location = {
        name: 'menu-planner-edit',
        params: {
          date: date,
          showDate: this.date,
          brand: this.brand
        }
      }

      if (this.package) {
        location.query = {
          package: this.package
        }
      }

      this.$router.push(location)
    },
    showControlReport(date) {
      let dialog = bootbox.dialog({
        title: `Raport kontrolny na ${this.getDayNameFromDate(date)} ${date}`,
        message: `<p><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> ${Translator.trans('common.loading')} </p>`,
        backdrop: true,
        onEscape: true,
        className: 'history-modal',
        size: 'large',
        buttons: {
          cancel: {
            label: Translator.trans('common.close'),
            className: 'btn btn-default',
            callback() {
              dialog.modal('hide')
            }
          },
        }
      })

      let url = Routing.generate('api_menu_planner_control_report', { date })

      this.$http.get(url).then(response => {
        dialog.find('.bootbox-body').html(response.bodyText)
      }, response => {
        this.handleAjaxError(response)
      })
    },
    getMealName(variantId, mealTypeId, date) {
      for (let i = 0; i < this.meals[date].length; i++) {
        if (Number(this.meals[date][i].variant_id) === Number(variantId) &&
          Number(this.meals[date][i].meal_type_id) === Number(mealTypeId)
        ) {
          return this.meals[date][i].meal_name
        }
      }
    },
    getProductionCost(variantId, mealTypeId, date) {
      for (let i = 0; i < this.meals[date].length; i++) {
        if (Number(this.meals[date][i].variant_id) === Number(variantId) &&
          Number(this.meals[date][i].meal_type_id) === Number(mealTypeId)
        ) {
          return (this.meals[date][i].production_cost).toFixed(2)
        }
      }
    },
    getMealAvgRate(variantId, mealTypeId, date) {
      for (let i = 0; i < this.meals[date].length; i++) {
        if (Number(this.meals[date][i].variant_id) === Number(variantId) &&
          Number(this.meals[date][i].meal_type_id) === Number(mealTypeId)
        ) {
          return (this.meals[date][i].avg_rate).toFixed(2)
        }
      }
    },
    getMealBadges(variantId, mealTypeId, date) {
      for (let i = 0; i < this.meals[date].length; i++) {
        if (Number(this.meals[date][i].variant_id) === Number(variantId) &&
            Number(this.meals[date][i].meal_type_id) === Number(mealTypeId)
        ) {
          return this.meals[date][i].badges
        }
      }
    },
    countUniqMeals(date) {
      let uniqMeals = []
      for (let i = 0; i < this.meals[date].length; i++) {
        if (!uniqMeals.includes(this.meals[date][i].meal_id)) {
          uniqMeals.push(this.meals[date][i].meal_id)
        }
      }
      return uniqMeals.length
    },
    showMealBadge(badgeId) {
      window.open(Routing.generate('badge_show', { id: badgeId }), '_blank')
    },
    getMealTypes() {
      this.loading++
      this.progress++

      let url = Routing.generate('api_get_meal_types', { context: 'dropdown' })

      this.$http.get(url).then(response => {
        this.mealTypes = response.data
        this.loading--
      }, response => {
        this.handleAjaxError(response)
        this.loading--
      })
    },
    getVariants() {
      this.loading++
      this.progress++

      let url = Routing.generate('api_get_menu_planner_variant', {
        context: 'list',
        brand: this.brand
      })

      if (this.package) {
        url += `?package=${this.package}`
      }

      Vue.http.get(url).then(response => {
        this.variants = response.data
        this.loading--
      }, response => {
        this.handleAjaxError(response)
        this.loading--
      })
    },
    getMeals() {
      this.loading++
      this.progress++

      let url = Routing.generate('api_show_menu_planner', {
        date: this.date,
        brand: this.brand
      })

      if (this.package) {
        url += `?package=${this.package}`
      }

      this.$http.get(url).then(response => {
        this.meals = response.data
        this.loading--
      }, response => {
        this.handleAjaxError(response)
        this.loading--
      })
    },
    trans(id) {
      return Translator.trans(id)
    },
    getDayNameFromDate(date) {
      return (new moment(date)).locale('pl').format('dddd')
    },
    isGranted() {
      return Object.values(window.appValues.menuPlanner.permissions).indexOf('MENU_PLANNER_UPDATE') !== -1
    }
  },
}
</script>

<style>
.menu-header {
  background: #3B3F51;
  color: #fff;
}

#menu-planner-table-show {
  table-layout: fixed;
}

#menu-planner-table-show td {
  vertical-align: middle;
}

.show-block-button {
  margin: 20px 0 0 0;
}

.show-block-button h3 {
  margin: 0;
}
</style>
